import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
function RoutePage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  });
  return <div>RoutePage</div>;
}

export default RoutePage;
